'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClientSideComponent = function (_Component) {
  (0, _inherits3.default)(ClientSideComponent, _Component);

  function ClientSideComponent() {
    var _ref;

    (0, _classCallCheck3.default)(this, ClientSideComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClientSideComponent.__proto__ || (0, _getPrototypeOf2.default)(ClientSideComponent)).call.apply(_ref, [this].concat(args)));

    _this.state = { isMounted: false };
    _this._mountTimeout = null;
    return _this;
  }

  (0, _createClass3.default)(ClientSideComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount(onDidMount) {
      var _this2 = this;

      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this._mountTimeout = setTimeout(function () {
        if (onDidMount) {
          onDidMount();
        }
        _this2.setState({ isMounted: true });
      }, delay);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount(onWillUnmount) {
      clearTimeout(this._mountTimeout);
      if (this.state.isMounted) {
        if (onWillUnmount) {
          onWillUnmount();
        }
      }
    }
  }]);
  return ClientSideComponent;
}(_react.Component); /**
                      React Component class for inheritance by the app components.
                      Implements client-side only functionality when `window` or `document` is required
                     */

exports.default = ClientSideComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/ClientSideComponent.js
// module id = 30
// module chunks = 1